var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suppliers"},[_vm._m(0),_c('hr'),_c('FormSuppliers',{attrs:{"_supplier":_vm.supplier},on:{"store":_vm.store}}),_c('LoadingComponent',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',{staticClass:"fw-600 fs-24 mb-0"},[_vm._v("Adicionar Fornecedor")])])])
}]

export { render, staticRenderFns }